"use client";

import { useMutation } from "@tanstack/react-query";
import type { VerifyPasswordResetRequest } from "cmw-client";
import { browserCmw } from "@/lib/ky/browser";

export type VerifyPasswordResetInput = VerifyPasswordResetRequest;

export const useVerifyPasswordReset = () =>
  useMutation({
    mutationFn: (body: VerifyPasswordResetInput) =>
      browserCmw.auth.verifyPasswordReset(body),
  });
